/**
 * Contexte d'en-tête d'une page montée à la racine (hors `/portal`, `/adminportal`, `/make`, `/marketplace`).
 *
 * Retour d'Olivier du 20.10 (`/profile`, après `/studio`) : toute page applicative connectée rend le même en-tête que le portail,
 * avec le menu « Module » condensé ; la barre legacy des menus côte à côte ne doit plus apparaître. Jusqu'ici une LISTE BLANCHE
 * (`/settings`, `/grid-columns`, `/parameter`…) décidait, et chaque nouvelle page racine (`/profile`, `/account`, `/billing`,
 * `/statistics`…) retombait sur la barre legacy. La règle est inversée : condensé partout, sauf les pages PUBLIQUES (layout
 * `routes/_public.tsx`, sans compte), qui gardent l'en-tête de vitrine.
 *
 * `/documentation` est publique mais garde l'en-tête condensé (UPT-1755) : elle n'est donc pas dans la liste.
 */
export const PUBLIC_PAGE_PREFIXES: readonly string[] = [
  '/login',
  '/register',
  '/sign-up',
  '/home',
  '/debug',
  '/about',
  '/terms',
  '/privacy',
  '/consent',
  '/help',
  '/noaccess',
  '/design-system',
  '/dentaris',
  '/e',
  '/preview',
  '/simulation',
  '/test',
];

/** Le chemin commence-t-il par ce préfixe, comparé segment par segment (`/admin` ne capture pas `/adminportal`) ? */
export const matchesPrefix = (path: string, prefix: string): boolean => path === prefix || path.startsWith(`${prefix}/`);

/** Page publique (vitrine, connexion, aperçu partagé…) : jamais le menu du portail. */
export const isPublicPage = (path: string): boolean => path === '/' || path === '' || PUBLIC_PAGE_PREFIXES.some((prefix) => matchesPrefix(path, prefix));

/** Espaces qui ont leur propre en-tête ou leur propre racine de portail. */
const OWN_CHROME_PREFIXES = ['/portal', '/adminportal', '/studio', '/make', '/marketplace'];

/** Page applicative montée à la racine (profil, compte, réglages, statistiques…) : en-tête du portail, menu « Module » condensé. */
export const isRootAppPage = (path: string): boolean =>
  !isPublicPage(path) && !OWN_CHROME_PREFIXES.some((prefix) => matchesPrefix(path, prefix));
